import { lookup as zipcodeLookup } from "zipcodes";

export const isValidZipCode = (zipCode: string) => {
  return zipcodeLookup(zipCode) as any;
};


export const getStateNameByStateCode = function (
  code: string,
  statesList: Array<{ name: string; state_code: string }>,
) {
  let state = statesList?.find(st => st.state_code === code);
  let res = {
    label: state?.name ?? '',
    value: state?.name ?? '',
  };
  return res as { label: string; value: string };
};